import { createAsyncThunk } from '@reduxjs/toolkit';
import { getUserDepartments } from '../api/get-departments';
import { ActionStatus } from '../../../common/constants/action-status';
import { StoreState } from '../../../store/store.interface';
import { handleApiError, ApiError } from '../../../common/utils/api-utils';

interface fetchDepartmentRequest {
  countryCode: string;
}

export const fetchDepartments = createAsyncThunk(
  'userProfile/fetchDepartments',
  async ({ countryCode }: fetchDepartmentRequest, thunkAPI) => {
    try {
      const data = await getUserDepartments({ countryCode });
      return { countryCode, data };
    } catch (error) {
      console.error(error);
      if (error instanceof ApiError) {
        handleApiError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  },
  {
    condition: ({ countryCode }, { getState }) => {
      const cached = (getState() as StoreState)
        .userProfileState.updateProfile.departmentCache?.[countryCode];
      return cached?.status !== ActionStatus.succeeded;
    },
  }
);
